import React, {Component} from 'react';
// import {Link} from 'react-router-dom';
import {HashLink as Link} from 'react-router-hash-link';
import CAE_recorrido from './../../../img/cae_recorrido.png';
import HoraInst from './../../../img/horaInstalacion.png';
import NumeroFunc from './../../../img/funcionariosCirculo.png';
import TomadosFila from './../../../img/tomadosFila.png';
import RepreCirculo from './../../../img/representantesCirculo.png';
import HoraVisita from './../../../img/horaVisitaCAE.png';
import CasillaNoInstalada from './../../../img/casillaNoInstalada.png';
import AccionesComunes from '../../AccionesComunes';

class InstalacionCasillas extends Component {

    componentDidMount(){
        var activeMenu = document.getElementById("jornadaElec");
        activeMenu.className += " active";
    }

    render () {
        return (
            <div className="container contenido">
                <AccionesComunes />
                <div className="migajas">
                    <small>
                        <Link to="./QueEsSIJE">Inicio</Link>
                        <span>Jornada Electoral</span>
                        <span>Instalación de casillas</span>
                    </small>
                </div>
                {/* <Migajas /> */}
                <div className="col-md-12 text-center mb-5">
                    <h1 className="tituloPagina">Instalación de casillas</h1>
                    <p className="centrar">
                        Para el SIJE los datos de instalación constituyen la base necesaria para comenzar a informar el estatus de la votación a la Juntas Distritales, Locales y los Organismos Públicos Locales (OPL).
                    </p>
                </div>
                <div className="row bordes text-center">
                    <div className="col-md-6 col-sm-12 text-left centrar-vertical">
                        <p>
                            Durante su primer recorrido los CAE visitan todas las casillas asignadas a su Área de Responsabilidad Electoral, y reportan la instalación de las casillas.
                        </p>
                    </div>
                    <div className="col-md-6 col-sm-12 centrar-vertical horizontal">
                        <img src={CAE_recorrido} alt="CAE visitando la casilla" />
                    </div>
                    <div className="col-md-12 mt-5 mb-5">
                        <strong>Los datos que reportan son:</strong>
                    </div>
                    <div className="col-md-4 col-lg-4 col-xl-4 col-xs-12 col-sm-6">
                        <img src={HoraInst} alt="Hora de instalación" />
                        <p><strong>Hora de instalación de la casilla</strong></p>
                    </div>
                    <div className="col-md-4 col-lg-4 col-xl-4 col-xs-12 col-sm-6">
                        <img src={NumeroFunc} alt="Funcionarios de casilla presentes" />
                        <p><strong>Número de funcionarios de casilla presentes</strong></p>
                    </div>
                    <div className="col-md-4 col-lg-4 col-xl-4 col-xs-12 col-sm-6">
                        <img src={TomadosFila} alt="Tomados de la fila" />
                        <p><strong>Número de funcionarios tomados de la fila</strong></p>
                    </div>
                    <div className="col-md-6 col-lg-6 col-xl-6 col-xs-12 col-sm-6">
                        <img src={RepreCirculo} alt="Representantes" />
                        <p><strong>Número de Representantes PP / CI presentes</strong></p>
                    </div>
                    <div className="col-md-6 col-lg-6 col-xl-6 col-xs-12 col-sm-6">
                        <img src={HoraVisita} alt="Hora de visita del CAE" />
                        <p><strong>Hora de visita del CAE a la casilla</strong></p>
                    </div>
                </div>
                <div className="row bordes">
                    <div className="col-md-6">
                        <h4>Casilla no instalada</h4>
                        <p>
                            Debido a que se reporta un incidente y no la instalación de casilla, los datos anteriores no se recaban.
                        </p>
                        <p>
                            Al tratarse de un incidente grave, el CAE debe reportarlo mediante llamada telefónica a la Sala SIJE, y reportarlo con el <Link to="./Glosario#i">incidente</Link>: <strong><i>“1. Casilla no instalada”</i></strong>.
                        </p>
                    </div>
                    <div className="col-md-6 centrar-vertical horizontal">
                        <img src={CasillaNoInstalada} alt="Casilla no instalada" />
                    </div>
                </div>
            </div>
        )
    }
}

export default InstalacionCasillas;